import { imageUrl } from "../imageUrl.js";
export const getSubjects = (standard, stream) => {
  return SUBJECT_DATA.filter(
    item => item.standard === standard && item.stream === stream
  );
};

export const SUBJECT_DATA = [
  // ======================
  // Standard 11 – Arts
  // ======================
  {
    kram: 1,
    standard: 11,
    stream: "arts",
    title: "English",
    image: "https://smartsathi.in/images/subject_icon/english.png",
  },
  {
    kram: 2,
    standard: 11,
    stream: "arts",
    title: "हिंदी",
    image: "https://smartsathi.in/images/subject_icon/hindi.png",
  },
  {
    kram: 3,
    standard: 11,
    stream: "arts",
    title: "ગુજરાતી",
    image: "https://smartsathi.in/images/subject_icon/gujarati.png",
  },
  {
    kram: 4,
    standard: 11,
    stream: "arts",
    title: "સંસ્કૃત",
    image: "https://smartsathi.in/images/subject_icon/sanskrit.png",
  },
  {
    kram: 5,
    standard: 11,
    stream: "arts",
    title: "ચિત્રકલા",
    image: "https://smartsathi.in/images/subject_icon/painting.png",
  },
  {
    kram: 6,
    standard: 11,
    stream: "arts",
    title: "કમ્પ્યુટર-અધ્યયન",
    image: "https://smartsathi.in/images/subject_icon/computer.png",
  },
  {
    kram: 7,
    standard: 11,
    stream: "arts",
    title: "યોગ, સ્વાસ્થ્ય અને શારીરિક શિક્ષણ",
    image: "https://smartsathi.in/images/subject_icon/sanskrit.png",
  },
  {
    kram: 8,
    standard: 11,
    stream: "arts",
    title: "અર્થશાસ્ત્ર",
    image: "images/subject_icon/english.png",
  },
  {
    kram: 9,
    standard: 11,
    stream: "arts",
    title: "ભૂગોળ",
    image: "https://smartsathi.in/images/subject_icon/geography.png",
  },
  {
    kram: 10,
    standard: 11,
    stream: "arts",
    title: "ઇતિહાસ",
    image: "https://smartsathi.in/images/subject_icon/history.png",
  },
  {
    kram: 11,
    standard: 11,
    stream: "arts",
    title: "મનોવિજ્ઞાન",
    image: "https://smartsathi.in/images/subject_icon/psychology.png",
  },
  {
    kram: 12,
    standard: 11,
    stream: "arts",
    title: "સમાજશાસ્ત્ર",
    image: "https://smartsathi.in/images/subject_icon/sociology.png",
  },
  {
    kram: 13,
    standard: 11,
    stream: "arts",
    title: "તત્વજ્ઞાન",
    image: "https://smartsathi.in/images/subject_icon/sanskrit.png",
  },

  // ======================
  // Standard 11 – Commerce
  // ======================
  {
    kram: 14,
    standard: 11,
    stream: "commerce",
    title: "English",
    image: "subjects/11/commerce/english.png",
  },
  {
    kram: 15,
    standard: 11,
    stream: "commerce",
    title: "हिंदी",
    image: "subjects/11/commerce/business.png",
  },
  {
    kram: 16,
    standard: 11,
    stream: "commerce",
    title: "ગુજરાતી",
    image: "subjects/11/commerce/economics.png",
  },
  {
    kram: 17,
    standard: 11,
    stream: "commerce",
    title: "સંસ્કૃત",
    image: "subjects/11/commerce/statistics.png",
  },
  {
    kram: 18,
    standard: 11,
    stream: "commerce",
    title: "ચિત્રકલા",
    image: "subjects/11/commerce/english.png",
  },
  {
    kram: 19,
    standard: 11,
    stream: "commerce",
    title: "કમ્પ્યુટર-અધ્યયન",
    image: "subjects/11/commerce/business.png",
  },
  {
    kram: 20,
    standard: 11,
    stream: "commerce",
    title: "વાણિજ્ય પત્રવ્યવહાર અને સેક્રેટરિયલ પ્રેક્ટિસ",
    image: "subjects/11/commerce/economics.png",
  },
  {
    kram: 21,
    standard: 11,
    stream: "commerce",
    title: "યોગ, સ્વાસ્થ્ય અને શારીરિક શિક્ષણ",
    image: "subjects/11/commerce/statistics.png",
  },
  {
    kram: 22,
    standard: 11,
    stream: "commerce",
    title: "અર્થશાસ્ત્ર",
    image: "subjects/11/commerce/statistics.png",
  },
  {
    kram: 23,
    standard: 11,
    stream: "commerce",
    title: "આંકડાશાસ્ત્ર",
    image: "subjects/11/commerce/english.png",
  },
  {
    kram: 24,
    standard: 11,
    stream: "commerce",
    title: "નામાનાં મૂળતત્ત્વો - 1",
    image: "subjects/11/commerce/business.png",
  },
  {
    kram: 25,
    standard: 11,
    stream: "commerce",
    title: "નામાનાં મૂળતત્ત્વો - 2",
    image: "subjects/11/commerce/economics.png",
  },
  {
    kram: 26,
    standard: 11,
    stream: "commerce",
    title: "વાણિજ્ય વ્યવસ્થા અને સંચાલન",
    image: "subjects/11/commerce/statistics.png",
  },

  // ======================
  // Standard 11 – Science
  // ======================
  {
    kram: 27,
    standard: 11,
    stream: "science",
    title: "English",
    image: "subjects/11/science/english.png",
  },
  {
    kram: 28,
    standard: 11,
    stream: "science",
    title: "हिंदी",
    image: "subjects/11/science/hindi.png",
  },
  {
    kram: 29,
    standard: 11,
    stream: "science",
    title: "ગુજરાતી",
    image: "subjects/11/science/gujarati.png",
  },
  {
    kram: 30,
    standard: 11,
    stream: "science",
    title: "ગણિત",
    image: "subjects/11/science/maths.png",
  },
  {
    kram: 31,
    standard: 11,
    stream: "science",
    title: "સંસ્કૃત",
    image: "subjects/11/science/physics1.png",
  },
  {
    kram: 32,
    standard: 11,
    stream: "science",
    title: "ચિત્રકલા",
    image: "subjects/11/science/physics2.png",
  },
  {
    kram: 33,
    standard: 11,
    stream: "science",
    title: "કમ્પ્યુટર-અધ્યયન",
    image: "subjects/11/science/chemistry1.png",
  },
  {
    kram: 34,
    standard: 11,
    stream: "science",
    title: "યોગ, સ્વાસ્થ્ય અને શારીરિક શિક્ષણ",
    image: "subjects/11/science/chemistry2.png",
  },
  {
    kram: 35,
    standard: 11,
    stream: "science",
    title: "અર્થશાસ્ત્ર",
    image: "subjects/11/science/biology.png",
  },

  {
    kram: 36,
    standard: 11,
    stream: "science",
    title: "ભૌતિકવિજ્ઞાન 1",
    image: "subjects/11/science/english.png",
  },
  {
    kram: 37,
    standard: 11,
    stream: "science",
    title: "ભૌતિકવિજ્ઞાન 2",
    image: "subjects/11/science/hindi.png",
  },
  {
    kram: 38,
    standard: 11,
    stream: "science",
    title: "જીવવિજ્ઞાન",
    image: "subjects/11/science/gujarati.png",
  },
  {
    kram: 39,
    standard: 11,
    stream: "science",
    title: "રસાયણ વિજ્ઞાન 1",
    image: "subjects/11/science/maths.png",
  },
  {
    kram: 40,
    standard: 11,
    stream: "science",
    title: "રસાયણ વિજ્ઞાન 2",
    image: "subjects/11/science/physics1.png",
  },

  // ======================
  // Standard 12 – Arts
  // ======================
  {
    kram: 41,
    standard: 12,
    stream: "arts",
    title: "English",
    image: "subjects/11/arts/english.png",
  },
  {
    kram: 42,
    standard: 12,
    stream: "arts",
    title: "हिंदी",
    image: "subjects/11/arts/history.png",
  },
  {
    kram: 43,
    standard: 12,
    stream: "arts",
    title: "ગુજરાતી",
    image: "subjects/11/arts/geography.png",
  },
  {
    kram: 44,
    standard: 12,
    stream: "arts",
    title: "સંસ્કૃત",
    image: "subjects/11/arts/psychology.png",
  },
  {
    kram: 45,
    standard: 12,
    stream: "arts",
    title: "ચિત્રકલા",
    image: "subjects/11/arts/english.png",
  },
  {
    kram: 46,
    standard: 12,
    stream: "arts",
    title: "કમ્પ્યુટર-અધ્યયન",
    image: "subjects/11/arts/history.png",
  },
  {
    kram: 47,
    standard: 12,
    stream: "arts",
    title: "યોગ, સ્વાસ્થ્ય અને શારીરિક શિક્ષણ",
    image: "subjects/11/arts/geography.png",
  },
  {
    kram: 48,
    standard: 12,
    stream: "arts",
    title: "અર્થશાસ્ત્ર",
    image: "subjects/11/arts/psychology.png",
  },
  {
    kram: 49,
    standard: 12,
    stream: "arts",
    title: "ભૂગોળ",
    image: "subjects/11/arts/english.png",
  },
  {
    kram: 50,
    standard: 12,
    stream: "arts",
    title: "ઇતિહાસ",
    image: "subjects/11/arts/history.png",
  },
  {
    kram: 51,
    standard: 12,
    stream: "arts",
    title: "મનોવિજ્ઞાન",
    image: "subjects/11/arts/geography.png",
  },
  {
    kram: 52,
    standard: 12,
    stream: "arts",
    title: "સમાજશાસ્ત્ર",
    image: "subjects/11/arts/psychology.png",
  },
  {
    kram: 53,
    standard: 12,
    stream: "arts",
    title: "તત્વજ્ઞાન",
  image: "subjects/11/arts/english.png",
  },

  // ======================
  // Standard 11 – Commerce
  // ======================
  {
    kram: 54,
    standard: 12,
    stream: "commerce",
    title: "English",
    image: "subjects/12/commerce/english.png",
  },
  {
    kram: 55,
    standard: 12,
    stream: "commerce",
    title: "हिंदी",
    image: "subjects/11/commerce/business.png",
  },
  {
    kram: 56,
    standard: 12,
    stream: "commerce",
    title: "ગુજરાતી",
    image: "subjects/11/commerce/economics.png",
  },
  {
    kram: 57,
    standard: 12,
    stream: "commerce",
    title: "સંસ્કૃત",
    image: "subjects/11/commerce/statistics.png",
  },
  {
    kram: 58,
    standard: 12,
    stream: "commerce",
    title: "ચિત્રકલા",
    image: "subjects/11/commerce/english.png",
  },
  {
    kram: 59,
    standard: 12,
    stream: "commerce",
    title: "કમ્પ્યુટર-અધ્યયન",
    image: "subjects/11/commerce/business.png",
  },
  {
    kram: 60,
    standard: 12,
    stream: "commerce",
    title: "વાણિજ્ય પત્રવ્યવહાર અને સેક્રેટરિયલ પ્રેક્ટિસ",
    image: "subjects/11/commerce/economics.png",
  },
  {
    kram: 61,
    standard: 12,
    stream: "commerce",
    title: "યોગ, સ્વાસ્થ્ય અને શારીરિક શિક્ષણ",
    image: "subjects/11/commerce/statistics.png",
  },
  {
    kram: 62,
    standard: 12,
    stream: "commerce",
    title: "અર્થશાસ્ત્ર",
    image: "subjects/11/commerce/statistics.png",
  },
  {
    kram: 63,
    standard: 12,
    stream: "commerce",
    title: "નામાનાં મૂળતત્ત્વો - 1",
    image: "subjects/11/commerce/english.png",
  },
  {
    kram: 64,
    standard: 12,
    stream: "commerce",
    title: "નામાનાં મૂળતત્ત્વો - 2",
    image: "subjects/11/commerce/business.png",
  },
  {
    kram: 65,
    standard: 12,
    stream: "commerce",
    title: "વાણિજ્ય વ્યવસ્થા અને સંચાલન",
    image: "subjects/11/commerce/economics.png",
  },
  {
    kram: 66,
    standard: 12,
    stream: "commerce",
    title: "આંકડાશાસ્ત્ર 1",
    image: "subjects/11/commerce/statistics.png",
  },
  {
    kram: 67,
    standard: 12,
    stream: "commerce",
    title: "આંકડાશાસ્ત્ર 2",
    image: "subjects/11/commerce/statistics.png",
  },
  // ======================
  // Standard 12 – Science
  // ======================
  {
    kram: 68,
    standard: 12,
    stream: "science",
    title: "English",
    image: "subjects/12/science/english.png",
  },
  {
    kram: 69,
    standard: 12,
    stream: "science",
    title: " हिंदी",
    image: "subjects/12/science/physics1.png",
  },
  {
    kram: 70,
    standard: 12,
    stream: "science",
    title: " ગુજરાતી",
    image: "subjects/12/science/physics2.png",
  },
  {
    kram: 71,
    standard: 12,
    stream: "science",
    title: "સંસ્કૃત",
    image: "subjects/12/science/chemistry1.png",
  },
  {
    kram: 72,
    standard: 12,
    stream: "science",
    title: "ચિત્રકલા",
    image: "subjects/12/science/chemistry2.png",
  },
  {
    kram: 73,
    standard: 12,
    stream: "science",
    title: "કમ્પ્યુટર-અધ્યયન",
    image: "subjects/12/science/biology.png",
  },
  {
    kram: 74,
    standard: 12,
    stream: "science",
    title: "યોગ, સ્વાસ્થ્ય અને શારીરિક શિક્ષણ",
    image: "subjects/12/science/biology.png",
  },
  {
    kram: 75,
    standard: 12,
    stream: "science",
    title: "અર્થશાસ્ત્ર",
    image: "subjects/12/science/english.png",
  },
  {
    kram: 76,
    standard: 12,
    stream: "science",
    title: " ભૌતિકવિજ્ઞાન 1",
    image: "subjects/12/science/physics1.png",
  },
  {
    kram: 77,
    standard: 12,
    stream: "science",
    title: " ભૌતિકવિજ્ઞાન 2",
    image: "subjects/12/science/physics2.png",
  },
  {
    kram: 78,
    standard: 12,
    stream: "science",
    title: "જીવવિજ્ઞાન",
    image: "subjects/12/science/chemistry1.png",
  },
  {
    kram: 79,
    standard: 12,
    stream: "science",
    title: "રસાયણ વિજ્ઞાન 1",
    image: "subjects/12/science/chemistry2.png",
  },
  {
    kram: 80,
    standard: 12,
    stream: "science",
    title: "રસાયણ વિજ્ઞાન 2",
    image: "subjects/12/science/biology.png",
  },
  {
    kram: 81,
    standard: 12,
    stream: "science",
    title: "ગણિત 1",
    image: "subjects/12/science/biology.png",
  },
  {
    kram: 82,
    standard: 12,
    stream: "science",
    title: "ગણિત 2",
    image: "subjects/12/science/biology.png",
  },
];